import { useQuery } from "@tanstack/react-query";
import { getClientInfoList } from "../../api/apiCallManager";

const useClientInfoList = () => {
  return useQuery({
    queryKey: ["getClientInfoListKey"],
    queryFn: getClientInfoList,
  });
};

export default useClientInfoList;
